import React from "react";
import { ExternalLink, MonitorPlay, Youtube } from "lucide-react";
import { getYoutubeId } from "../lib/api";

export function getYoutubeWatchUrl(url) {
  if (!url) return null;
  const id = getYoutubeId(url);
  if (id) return `https://www.youtube.com/watch?v=${id}`;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return null;
}

export function YoutubeWatchButton({ url, className = "", label = "YouTube'da İzle" }) {
  const watchUrl = getYoutubeWatchUrl(url);
  if (!watchUrl) return null;

  return (
    <a
      href={watchUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold border border-[var(--tv-border)] text-white hover:border-[rgba(168,85,247,0.5)] hover:bg-[rgba(139,92,246,0.08)] transition-colors ${className}`}
    >
      <Youtube size={16} className="text-red-400" />
      {label}
      <ExternalLink size={14} className="text-[var(--tv-muted)]" />
    </a>
  );
}

export function SiteWatchBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold bg-[rgba(139,92,246,0.15)] border border-[rgba(168,85,247,0.35)] text-white ${className}`}
    >
      <MonitorPlay size={16} className="text-[var(--tv-purple-bright)]" />
      Sitede izleniyor
    </span>
  );
}
